// ANGULAR DEPENDANCY
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';

// EXTERNAL DEPENDANCY
import { Observable, of } from 'rxjs';

// SERVICE
import { TokenStorageService } from '../../state/core/services/token-storage/token-storage.service';

// CONSTANT
import { ROUTE_CONSTANTS } from '../../constants/route';

// MOMENT-TIMEZONE
import momentTimeZone from 'moment-timezone';
import { LocalStorageUtil } from '../utils/local-storage-util';

/**
 * This component used to verify if the accesstoken and business token exists
 * @author Vikas thakkar <vikasthakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 29/04/2020 (Vikas thakkar <vikasthakkar@saeculumsolutions.com>) AuthBusinessGuard created
 */
@Injectable({
  providedIn: 'root',
})
export class AuthBusinessGuard implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    private tokenStorageService: TokenStorageService,
  ) {
  }

  /**
   * Check if the ActivatedComponent can be activated or not based on the token
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   */
  canActivate(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.checkIfAuthorized(route, state);
  }

  /**
   * Checks if the ActivatedComponent's can be activated or not based on the token
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   */
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.checkIfAuthorized(childRoute, state);
  }

  /**
   * Checks if the Activated component is authorized
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   */
  checkIfAuthorized(route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {
    const businessToken = this.tokenStorageService.validateBusinessToken();
    const accessToken = this.tokenStorageService.validateAccessToken();

    // validate both access token and business token
    if (accessToken && businessToken) {
      momentTimeZone.tz.setDefault(LocalStorageUtil.getTimeZone());

      return of(true);
    }

    // validate access token
    if (accessToken) {
      this.router.navigate([ROUTE_CONSTANTS.CONTAINER.BUSINESS, ROUTE_CONSTANTS.BUSINESS.CHANGE_BUSINESS]);
      return of(false);
    }

    // navigate to sign in page
    this.router.navigate([ROUTE_CONSTANTS.CONTAINER.AUTH, ROUTE_CONSTANTS.AUTH.LOGIN], { queryParams: { returnUrl: state.url } });
    return of(false);

  }

}
